import { render, staticRenderFns } from "./PackageVersionDescriptorList.vue?vue&type=template&id=7ea97cee&"
import script from "./PackageVersionDescriptorList.vue?vue&type=script&lang=js&"
export * from "./PackageVersionDescriptorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports